import axios from 'axios';
import { getStatusValidator } from '@garmin/axios-request';
import { baseRoute } from '../helpers/baseRoutes';

export default {
  async addOptIn(programKey, phoneUuid, originalStatus, newStatus, locale) {
    try {
      const requestConfig = {
        url: `${window.location.origin}${baseRoute}/api/smsOptIn/addOptIn`,
        method: 'POST',
        data: {
          programKey,
          phoneUuid,
          originalStatus,
          newStatus,
          locale,
        },
        validateStatus: getStatusValidator([[200, 200]]),
      };
      const response = await axios.request(requestConfig);
      return response;
    } catch (error) {
      throw new Error(`smsOptInService.addOptIn() exception: ${error.message}`, { cause: error });
    }
  },
};
